import React, { forwardRef } from 'react';
import tw from 'twin.macro';
import Button from 'components/Buttons/Button';
import DragHandleHorizontal from 'components/Icons/icons/DragHandleVertical';
import { TagItem } from 'components/Form/TagPicker/TagItem';

export const ItemOverlay = forwardRef(({ id, ...props }: any, ref) => (
  <div tw="flex items-center" ref={ref as any}>
    <div>
      <Button minimal icon={DragHandleHorizontal as any} />
    </div>
    <div css={[tw`flex flex-grow min-w-0 mr-1`]}>
      <TagItem value={props.tag} />
    </div>
  </div>
));

export default ItemOverlay;
